export const SING_POST_CARRIER_TYPE = 'SingPost';
export const NINJA_VAN_CARRIER_TYPE = 'NinjaVanStandard';
export const MORNING_EXPRESS_CARRIER_TYPE = 'MorningExpress';
export const TELEPORT_CARRIER_TYPE = 'Teleport';
export const PLAIN_LABEL_CARRIER_TYPE = 'PlainLabel';
export const EPARCEL_CARRIER_TYPE = 'Eparcel';
export const COURIERS_PLEASE_CARRIER_TYPE = 'CouriersPlease';
export const HUBBED_CARRIER_TYPE = 'Hubbed';
export const TNT_CARRIER_TYPE = 'Tnt';
export const ALLIED_EXPRESS_CARRIER_TYPE = 'AlliedExpressOvernight';

export const CARRIERS_SUPPORTING_DROPOFF: CarrierType[] = [
  SING_POST_CARRIER_TYPE,
  NINJA_VAN_CARRIER_TYPE,
  MORNING_EXPRESS_CARRIER_TYPE,
];

export type CarrierType =
  | 'Hubbed'
  | 'Eparcel'
  | 'CouriersPlease'
  | 'Tnt'
  | 'Bonds'
  | 'SingPost'
  | 'Teleport'
  | 'NinjaVanStandard'
  | 'MorningExpress'
  | 'PlainLabel'
  | 'AlliedExpressOvernight';

export interface Carrier {
  carrier_type: CarrierType;
  carrier_name: string;
  service_level: string;
  dropoff: boolean;
  estimated_transit_time?: string;
  error?: string;
}
